---
meta:
  - title: Notificaciones de La Gaceta y Boletín Judicial - IUSPRO Docs
  - description: Aprende a configurar alertas de interés para recibir correos automáticos con coincidencias relevantes.
---

# Notificaciones de La Gaceta y Boletín Judicial

La función de Notificaciones le permite definir temas de interés para que IUSPRO revise automáticamente publicaciones
nuevas de:

- **La Gaceta**
- **Boletín Judicial**

Cuando hay coincidencias, recibe un correo con los hallazgos, la confianza y la cita exacta del documento.

## Costo

Esta funcionalidad está **incluida sin costo adicional** mientras tenga una **suscripción activa**.

## ¿Cómo funciona?

### Paso 1: Abra Notificaciones

En el menú lateral vaya a **Notificaciones**.

### Paso 2: Defina sus intereses

Verá dos cuadros de texto:

- Intereses en **La Gaceta**
- Intereses en **Boletín Judicial**

Puede escribir varios temas en cada cuadro, en lenguaje natural.

Ejemplos:

- `remates de Pérez Zeledón`
- `remate de vehículo placa CL 441148`
- `sociedad ABC S.A. y Juan Pérez`
- `edicto relacionado con herencias en Limón`

### Paso 3: Guarde

Al guardar, el sistema procesa sus instrucciones en segundo plano y las usa para detectar coincidencias en nuevas
publicaciones.

### Paso 4: Reciba los correos automáticos

IUSPRO envía notificaciones cuando termina de procesar cada fuente:

- Un digest para **La Gaceta**
- Un digest para **Boletín Judicial**

Cada resultado incluye:

- Tema que coincidió
- Fuente (Gaceta o Boletín Judicial)
- Fecha del documento
- Confianza
- Cita textual exacta y contexto

### Paso 5: Revise historial

En la misma pantalla de Notificaciones encontrará el historial de envíos para auditoría y seguimiento.

## ¿Qué pasa si se publica más tarde?

Si una edición de La Gaceta o del Boletín Judicial se publica más tarde en el día, el sistema la procesa y envía el
digest de esa fuente cuando termina, sin esperar al día siguiente.

## Recomendaciones para mejores resultados

- Use nombres propios completos cuando busque personas o sociedades.
- Incluya identificadores concretos cuando existan (placa, cédula, expediente).
- Separe temas diferentes en frases claras.
- Evite instrucciones demasiado amplias como `todo sobre civil`, porque generan resultados menos precisos.

## Ejemplo completo

### Intereses en Boletín Judicial

`Remates de fincas en Pérez Zeledón; remate del vehículo CL 441148`

### Qué puede recibir

- Coincidencia: `remate del vehículo CL 441148`
- Fuente: `Boletín Judicial`
- Confianza: `100%`
- Cita: extracto textual del aviso donde aparece la placa

## Próximo paso

Abra [Notificaciones](/monitores) y guarde sus temas de interés.
